import * as React from 'react';
import OriginalWrapper from 'gatsby-theme-docz/src/wrapper';

const Wrapper = ({ children }) => {
	const style = { background: '#eb354e', padding: 30 };
	return (
		<div style={style}>
			<OriginalWrapper>{children}</OriginalWrapper>
		</div>
	);
};

export default Wrapper;
